// extracted by mini-css-extract-plugin
export default {"wrapper":"confirmation_wrapper__1V7qj","controls":"confirmation_controls__xqzkK","opacity-transition":"confirmation_opacity-transition__y8tiB"};